import react from 'react';
import '../cssfiles/footer.css';


function Footer(){
    return(
        <>
         <footer>
            <p className='footer'>© 2025 by <a href="https://www.instagram.com/oxomgamedev?igsh=MWk2Y2R5b25qZmM1cg==">Samim Ahmed</a> | All Rights Reserved</p>
            <p> This website is developed by Samim Ahmed</p>
         </footer>
        </>
    )
}
export default Footer;